import { createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";
import { CustomApiHandler } from "@NA/Store/CustomHandlerCreator/CustomHandlerCreator";
import { getStates } from "@NA/Services/ADIGetStatesService";

interface GetStatesParameter {
    languageId: string;
    expand: string;
    onSuccess?: (result: any) => void;
    onError?: (error: string) => void;
}

interface GetStatesApiParameter {
    languageId: string;
    expand: string;
    result?:any;
}

type HandlerType = CustomApiHandler<
    GetStatesParameter,
    GetStatesApiParameter
>;

export const GetStates: HandlerType = async props => {
    const { languageId, expand } = props.parameter;
    props.apiResult = await getStates({ languageId, expand });
};

export const chain = [GetStates];

const getStatesData = createHandlerChainRunner(chain, "GetStates");
export default getStatesData;
